// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.skill-container {
  width: 100%;
  position: absolute;
  z-index: 100;
  align-self: center;
  justify-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.perks {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 28px;
  color: #aeaba2;
  transform-origin: top;
  position: relative;
}
.perks__content {
  display: flex;
  flex-direction: column;
  z-index: 9999;
  width: 1720px;
  height: 980px;
  padding: 0 32px;
}
.perks__header {
  margin: 28px auto auto;
  display: flex;
  justify-content: space-between;
  width: 90%;
  color: #ebe8e1;
}
.perks__list-container {
  height: 100%;
}
.perks__list {
  padding: 28px 0;
  display: flex;
  gap: 74px;
}
.perks__category {
  display: flex;
  position: relative;
  height: fit-content;
  width: 272px;
  flex-wrap: wrap;
  column-gap: 16px;
  row-gap: 32px;
  z-index: 10;
  margin: 0;
  padding: 0;
  list-style: none;
}
.perks__perk {
  width: 128px;
  height: 128px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  border-radius: 6px;
  border: 2px solid #8d8a82;
  background: rgba(255, 255, 255, 0.04);
  color: #8d8a82;
  transition: color 160ms, border-color 160ms, background-color 160ms, opacity 160ms;
  opacity: 0.75;
}
@media (prefers-reduced-motion: reduce) {
  .perks__perk {
    transition: none;
  }
}
.perks__perk__icon {
  position: relative;
  bottom: -12px;
  height: 70px;
}
.perks__perk__icon svg {
  fill: #8d8a82;
}
.perks__perk__price {
  position: relative;
  bottom: -4px;
  gap: 8px;
  display: flex;
  align-items: center;
  margin: 0;
}
.perks__perk:hover {
  opacity: 1;
  background: rgba(255, 255, 255, 0.09);
  cursor: pointer;
}
.perks__perk:focus {
  outline: none;
  background: rgba(255, 255, 255, 0.12);
}
.perks__perk:focus-visible {
  outline: 3px solid var(--gold-light);
  outline-offset: 3px;
}
.perks__perk--absolute {
  position: absolute;
  bottom: -160px;
}
.perks__perk--left {
  left: 0;
}
.perks__perk--right {
  right: 0;
}
.perks__perk--level-0 {
  opacity: 0.5;
}
.perks__perk--level-0:focus {
  opacity: 1;
  color: var(--gold-dark);
  border-color: var(--gold-dark);
}
.perks__perk--level-0:focus svg {
  fill: var(--gold-dark);
}
.perks__perk--level-0:focus .perks__exp {
  background-color: var(--gold-dark);
}
.perks__perk--level-0.perks__perk--short:focus {
  color: var(--gold-main);
  border-color: var(--gold-main);
}
.perks__perk--level-0.perks__perk--short:focus svg {
  fill: var(--gold-main);
}
.perks__perk--level-0.perks__perk--short:focus .perks__exp {
  background-color: var(--gold-main);
}
.perks__perk--level-1 {
  color: var(--gold-dark);
  border-color: var(--gold-dark);
}
.perks__perk--level-1 svg {
  fill: var(--gold-dark);
}
.perks__perk--level-1 .perks__exp {
  background-color: var(--gold-dark);
}
.perks__perk--level-1:focus {
  color: var(--gold-main);
  border-color: var(--gold-main);
}
.perks__perk--level-1:focus svg {
  fill: var(--gold-main);
}
.perks__perk--level-1:focus .perks__exp {
  background-color: var(--gold-main);
}
.perks__perk--level-2 {
  color: var(--gold-main);
  border-color: var(--gold-main);
}
.perks__perk--level-2 svg {
  fill: var(--gold-main);
}
.perks__perk--level-2 .perks__exp {
  background-color: var(--gold-main);
}
.perks__perk--level-2:focus {
  color: var(--gold-light);
  border-color: var(--gold-light);
}
.perks__perk--level-2:focus svg {
  fill: var(--gold-light);
}
.perks__perk--level-2:focus .perks__exp {
  background-color: var(--gold-light);
}
.perks__perk--level-2.perks__perk--short:focus {
  color: #8fbf8a;
  border-color: #8fbf8a;
}
.perks__perk--level-2.perks__perk--short:focus svg {
  fill: #8fbf8a;
}
.perks__perk--level-2.perks__perk--short:focus .perks__exp {
  background-color: #8fbf8a;
}
.perks__perk--level-3 {
  color: var(--gold-light);
  border-color: var(--gold-light);
}
.perks__perk--level-3 svg {
  fill: var(--gold-light);
}
.perks__perk--level-3 .perks__exp {
  background-color: var(--gold-light);
}
.perks__perk--level-3:focus {
  color: #8fbf8a;
  border-color: #8fbf8a;
}
.perks__perk--level-3:focus svg {
  fill: #8fbf8a;
}
.perks__perk--level-3:focus .perks__exp {
  background-color: #8fbf8a;
}
.perks__perk--level-4 {
  color: #8fbf8a;
  border-color: #8fbf8a;
}
.perks__perk--level-4 svg {
  fill: #8fbf8a;
}
.perks__perk--level-4 .perks__exp {
  background-color: #8fbf8a;
}
.perks__exp-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
}
.perks__exp-container__line {
  display: flex;
  position: relative;
  gap: 18px;
}
.perks__exp-container__line__price {
  display: flex;
  gap: 8px;
  align-items: center;
}
.perks__exp {
  border-radius: 50%;
  background-color: #8d8a82;
  width: 16px;
  height: 16px;
  display: inline-block;
}
.perks__footer {
  display: flex;
  padding: 24px 6px;
  min-height: 245px;
  position: relative;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}
.perks__footer__description {
  width: 60%;
  padding-right: 24px;
}
.perks__footer__description__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 34px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  margin: 0;
}
.perks__footer__description__text {
  margin: 14px 0 0;
  font-size: 28px;
  line-height: 1.45;
  color: #aeaba2;
}
.perks__footer__buttons {
  width: 20%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.perks__footer__buttons__confirm {
  display: flex;
  gap: 11px;
}
.perks__footer__exit-button {
  justify-content: center;
  display: flex;
  align-items: end;
  width: 20%;
  bottom: 24px;
  right: 0;
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/features/skillsMenu/styles.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AAOA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AALF;;AAQA;EACE,yDDEU;ECDV,eAAA;EACA,cDRO;ECSP,qBAAA;EACA,kBAAA;AALF;AAOE;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;AALJ;AAQE;EACE,sBAAA;EACA,aAAA;EACA,8BAAA;EACA,UAAA;EACA,cD3BG;ACqBP;AASE;EACE,YAAA;AAPJ;AAUE;EACE,eAAA;EACA,aAAA;EACA,SAAA;AARJ;AAWE;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AATJ;AAYE;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBDxDK;ECyDL,yBAAA;EACA,qCDnES;ECoET,cD9DK;EC+DL,kFAAA;EAEA,aAAA;AAXJ;AAaI;EAfF;IAe4C,gBAAA;EAT5C;AACF;AAUI;EACE,kBAAA;EACA,aAAA;EACA,YAAA;AARN;AASM;EACE,aD1EC;ACmET;AAWI;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AATN;AAYI;EACE,UAAA;EACA,qCAAA;EACA,eAAA;AAVN;AAYI;EACE,aAAA;EACA,qCAAA;AAVN;AAYI;EACE,oCAAA;EACA,mBAAA;AAVN;AAcE;EACE,kBAAA;EACA,cAAA;AAZJ;AAeE;EACE,OAAA;AAbJ;AAgBE;EACE,QAAA;AAdJ;AAiBE;EACE,YAAA;AAfJ;AAgBI;EACE,UAAA;EACA,uBArII;EAsIJ,8BAtII;AAwHV;AAeM;EACE,sBAxIE;AA2HV;AAeM;EACE,kCA3IE;AA8HV;AAiBM;EACE,uBA/IE;EAgJF,8BAhJE;AAiIV;AAgBQ;EACE,sBAlJA;AAoIV;AAgBQ;EACE,kCArJA;AAuIV;AAoBE;EACE,uBA7JM;EA8JN,8BA9JM;AA4IV;AAmBI;EACE,sBAhKI;AA+IV;AAmBI;EACE,kCAnKI;AAkJV;AAmBI;EACE,uBArKI;EAsKJ,8BAtKI;AAqJV;AAkBM;EACE,sBAxKE;AAwJV;AAkBM;EACE,kCA3KE;AA2JV;AAqBE;EACE,uBAjLM;EAkLN,8BAlLM;AA+JV;AAoBI;EACE,sBApLI;AAkKV;AAoBI;EACE,kCAvLI;AAqKV;AAoBI;EACE,wBAzLI;EA0LJ,+BA1LI;AAwKV;AAmBM;EACE,uBA5LE;AA2KV;AAmBM;EACE,mCA/LE;AA8KV;AAqBM;EACE,cDtLE;ECuLF,qBDvLE;ACoKV;AAoBQ;EACE,aDzLA;ACuKV;AAoBQ;EACE,yBD5LA;AC0KV;AAwBE;EACE,wBAjNM;EAkNN,+BAlNM;AA4LV;AAuBI;EACE,uBApNI;AA+LV;AAuBI;EACE,mCAvNI;AAkMV;AAuBI;EACE,cD5MI;EC6MJ,qBD7MI;ACwLV;AAsBM;EACE,aD/ME;AC2LV;AAsBM;EACE,yBDlNE;AC8LV;AAyBE;EACE,cDxNM;ECyNN,qBDzNM;ACkMV;AAwBI;EACE,aD3NI;ACqMV;AAwBI;EACE,yBD9NI;ACwMV;AA0BE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;AAxBJ;AA0BI;EACE,aAAA;EACA,kBAAA;EACA,SAAA;AAxBN;AA0BM;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AAxBR;AA6BE;EACE,kBAAA;EACA,yBD1PK;EC2PL,WAAA;EACA,YAAA;EACA,qBAAA;AA3BJ;AA8BE;EACE,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,+CAAA;AA5BJ;AA8BI;EACE,UAAA;EACA,mBAAA;AA5BN;AA8BM;ED1OJ,kDA3BW;EA4BX,gBAAA;EACA,eCyOyB;EDxOzB,iBAAA;EACA,sBAAA;EACA,cAxCK;EC+QC,SAAA;AAvBR;AA0BM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cDrRC;AC6PT;AA2BI;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;AAzBN;AA0BM;EACE,aAAA;EACA,SAAA;AAxBR;AA2BI;EACE,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;AAzBN","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","// Skills (perks) menu. A fixed 1720x980 canvas that index.tsx scales to the\n// window and that stays centred. The panel itself is drawn by SkyrimFrame\n// (ink panel behind the content); this file styles what sits on it, in the\n// shared ink look (see theme/_ink.scss).\n@use '../../theme/ink' as ink;\n\n// Perk level tones: none, then the accent in three steps, then success for a\n// maxed perk. The next level's tone is previewed on focus.\n$level-0: ink.$text-3;\n$level-1: var(--gold-dark);\n$level-2: var(--gold-main);\n$level-3: var(--gold-light);\n$level-4: ink.$success;\n\n$regular: 160ms;\n\n.skill-container {\n  width: 100%;\n  position: absolute;\n  z-index: 100;\n  align-self: center;\n  justify-self: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.perks {\n  font-family: ink.$font-text;\n  font-size: 28px;\n  color: ink.$text-2;\n  transform-origin: top;\n  position: relative;\n\n  &__content {\n    display: flex;\n    flex-direction: column;\n    z-index: 9999;\n    width: 1720px;\n    height: 980px;\n    padding: 0 32px;\n  }\n\n  &__header {\n    margin: 28px auto auto;\n    display: flex;\n    justify-content: space-between;\n    width: 90%;\n    color: ink.$text;\n  }\n\n  &__list-container {\n    height: 100%;\n  }\n\n  &__list {\n    padding: 28px 0;\n    display: flex;\n    gap: 74px;\n  }\n\n  &__category {\n    display: flex;\n    position: relative;\n    height: fit-content;\n    width: 272px;\n    flex-wrap: wrap;\n    column-gap: 16px;\n    row-gap: 32px;\n    z-index: 10;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n\n  &__perk {\n    width: 128px;\n    height: 128px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: start;\n    border-radius: ink.$radius;\n    border: 2px solid $level-0;\n    background: ink.$ink-raised;\n    color: $level-0;\n    transition: color $regular, border-color $regular, background-color $regular,\n      opacity $regular;\n    opacity: 0.75;\n\n    @media (prefers-reduced-motion: reduce) { transition: none; }\n\n    &__icon {\n      position: relative;\n      bottom: -12px;\n      height: 70px;\n      svg {\n        fill: $level-0;\n      }\n    }\n\n    &__price {\n      position: relative;\n      bottom: -4px;\n      gap: 8px;\n      display: flex;\n      align-items: center;\n      margin: 0;\n    }\n\n    &:hover {\n      opacity: 1;\n      background: rgba(255, 255, 255, 0.09);\n      cursor: pointer;\n    }\n    &:focus {\n      outline: none;\n      background: rgba(255, 255, 255, 0.12);\n    }\n    &:focus-visible {\n      outline: 3px solid var(--gold-light);\n      outline-offset: 3px;\n    }\n  }\n\n  &__perk--absolute {\n    position: absolute;\n    bottom: -160px;\n  }\n\n  &__perk--left {\n    left: 0;\n  }\n\n  &__perk--right {\n    right: 0;\n  }\n\n  &__perk--level-0 {\n    opacity: 0.5;\n    &:focus {\n      opacity: 1;\n      color: $level-1;\n      border-color: $level-1;\n      svg {\n        fill: $level-1;\n      }\n      .perks__exp {\n        background-color: $level-1;\n      }\n    }\n    &.perks__perk--short {\n      &:focus {\n        color: $level-2;\n        border-color: $level-2;\n        svg {\n          fill: $level-2;\n        }\n        .perks__exp {\n          background-color: $level-2;\n        }\n      }\n    }\n  }\n\n  &__perk--level-1 {\n    color: $level-1;\n    border-color: $level-1;\n    svg {\n      fill: $level-1;\n    }\n    .perks__exp {\n      background-color: $level-1;\n    }\n    &:focus {\n      color: $level-2;\n      border-color: $level-2;\n      svg {\n        fill: $level-2;\n      }\n      .perks__exp {\n        background-color: $level-2;\n      }\n    }\n  }\n\n  &__perk--level-2 {\n    color: $level-2;\n    border-color: $level-2;\n    svg {\n      fill: $level-2;\n    }\n    .perks__exp {\n      background-color: $level-2;\n    }\n    &:focus {\n      color: $level-3;\n      border-color: $level-3;\n      svg {\n        fill: $level-3;\n      }\n      .perks__exp {\n        background-color: $level-3;\n      }\n    }\n    &.perks__perk--short {\n      &:focus {\n        color: $level-4;\n        border-color: $level-4;\n        svg {\n          fill: $level-4;\n        }\n        .perks__exp {\n          background-color: $level-4;\n        }\n      }\n    }\n  }\n\n  &__perk--level-3 {\n    color: $level-3;\n    border-color: $level-3;\n    svg {\n      fill: $level-3;\n    }\n    .perks__exp {\n      background-color: $level-3;\n    }\n    &:focus {\n      color: $level-4;\n      border-color: $level-4;\n      svg {\n        fill: $level-4;\n      }\n      .perks__exp {\n        background-color: $level-4;\n      }\n    }\n  }\n\n  &__perk--level-4 {\n    color: $level-4;\n    border-color: $level-4;\n    svg {\n      fill: $level-4;\n    }\n    .perks__exp {\n      background-color: $level-4;\n    }\n  }\n\n  &__exp-container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-top: 8px;\n\n    &__line {\n      display: flex;\n      position: relative;\n      gap: 18px;\n\n      &__price {\n        display: flex;\n        gap: 8px;\n        align-items: center;\n      }\n    }\n  }\n\n  &__exp {\n    border-radius: 50%;\n    background-color: $level-0;\n    width: 16px;\n    height: 16px;\n    display: inline-block;\n  }\n\n  &__footer {\n    display: flex;\n    padding: 24px 6px;\n    min-height: 245px;\n    position: relative;\n    border-top: 1px solid ink.$line;\n\n    &__description {\n      width: 60%;\n      padding-right: 24px;\n\n      &__title {\n        @include ink.title(34px);\n        margin: 0;\n      }\n\n      &__text {\n        margin: 14px 0 0;\n        font-size: 28px;\n        line-height: 1.45;\n        color: ink.$text-2;\n      }\n    }\n    &__buttons {\n      width: 20%;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      align-items: center;\n      &__confirm {\n        display: flex;\n        gap: 11px;\n      }\n    }\n    &__exit-button {\n      justify-content: center;\n      display: flex;\n      align-items: end;\n      width: 20%;\n      bottom: 24px;\n      right: 0;\n      position: absolute;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
